import { useEffect, useState } from "react";
import IconSettings from "../../layout/left_menu_icons/icon_menu_settings_default.svg";
import TechnologyCategoryPage from "./TechnologyCategoryManagement/TechnologyCategoryPage";
import QuizPage from "./QuizManagement/QuizPage";
import SkillPage from "./SkillManagement/SkillPage";
import TechnologySubCategoryPage from "./TechnologySubcategoryManagement/TechnologySubCategoryPage";
import InterviewSettingContextProvider from "./interviewSettingsContext";
import { useTranslation } from "react-i18next";
import { useGeneralContext } from "../General/Context";
import BusinessAreaListPage from "./BusinessArea/BusinessAreaListPage";
import TechByTechRolePage from "./TechByTechRole/TechByTechRolePage";
import TechAreaPage from "./TechArea/TechAreaPage";
import TechRolePage from "./TechRole/TechRolePage";
import { Tab } from "bootstrap";

export default function InterviewSettings() {
  const { t } = useTranslation();
  const [openForm, setOpenForm] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const TABS = {
    BUSINESSAREA: 0,
    TECHAREA: 1,
    TECHROLE: 2,
    TECHBYTECHROLE: 3,
    SKILLS: 4,
    CATEGORIES: 5,
    SUBCATEGORIES: 6
  };
  const { userInformation } = useGeneralContext();

  useEffect(() => (document.title = t("AtVitae - Interview Settings")), [t]);

  return (
    <InterviewSettingContextProvider>
      <div>
        <div>
          <header className="page-header">
            <div className="header-title">
              <div className="title">
                <img src={IconSettings} alt="ni-icon" />
                <h1>{t("Interview Settings")}</h1>
              </div>
              <div className="subtitle">
                {t("Settings / Interview Settings")}
              </div>
            </div>
          </header>
          <div className="header-tabs">
            <ul className="nav nav-tabs" role="tablist">
              <li
                className={`nav-item ${
                  TABS.BUSINESSAREA == currentTab ? "ative" : ""
                }`}
                role="presentation"
              >
                <a
                  className={`nav-link ${
                    TABS.BUSINESSAREA == currentTab ? "active" : ""
                  }`}
                  onClick={() => setCurrentTab(TABS.BUSINESSAREA)}
                >
                  {t("Business Area")}
                </a>
              </li>
              <li
                className={`nav-item ${
                  TABS.TECHAREA == currentTab ? "ative" : ""
                }`}
                role="presentation"
              >
                <a
                  className={`nav-link ${
                    TABS.TECHAREA == currentTab ? "active" : ""
                  }`}
                  onClick={() => setCurrentTab(TABS.TECHAREA)}
                >
                  {t("Tech Area")}
                </a>
              </li>
              <li
                className={`nav-item ${
                  TABS.TECHROLE == currentTab ? "ative" : ""
                }`}
                role="presentation"
              >
                <a
                  className={`nav-link ${
                    TABS.TECHROLE == currentTab ? "active" : ""
                  }`}
                  onClick={() => setCurrentTab(TABS.TECHROLE)}
                >
                  {t("Tech Role")}
                </a>
              </li>{" "}
              <li
                className={`nav-item ${
                  TABS.TECHBYTECHROLE == currentTab ? "ative" : ""
                }`}
                role="presentation"
              >
                <a
                  className={`nav-link ${
                    TABS.TECHBYTECHROLE == currentTab ? "active" : ""
                  }`}
                  onClick={() => setCurrentTab(TABS.TECHBYTECHROLE)}
                >
                  {t("Tech By TechRole")}
                </a>
              </li>
              <li
                className={`nav-item ${
                  TABS.SKILLS == currentTab ? "ative" : ""
                }`}
                role="presentation"
              >
                <a
                  className={`nav-link ${
                    TABS.SKILLS == currentTab ? "active" : ""
                  }`}
                  onClick={() => setCurrentTab(TABS.SKILLS)}
                >
                  {t("Skill Management")}
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            {currentTab == TABS.SKILLS && (
              <div id="skillList" role="tabpanel">
                <SkillPage
                  openForm={openForm}
                  setOpenForm={setOpenForm}
                  currentTab={currentTab}
                />
              </div>
            )}

            {currentTab == TABS.BUSINESSAREA && (
              <div id="businessAreaList" role="tabpanel">
                <BusinessAreaListPage currentTab={currentTab} />
              </div>
            )}

            {currentTab == TABS.TECHBYTECHROLE && (
              <div id="techByTechRole" role="tabpanel">
                <TechByTechRolePage currentTab={currentTab} />
              </div>
            )}

            {currentTab == TABS.TECHAREA && (
              <div id="techArea" role="tabpanel">
                <TechAreaPage currentTab={currentTab} />
              </div>
            )}

            {currentTab == TABS.TECHROLE && (
              <div id="techRole">
                <TechRolePage currentTab={currentTab} />
              </div>
            )}
          </div>
        </div>
      </div>
    </InterviewSettingContextProvider>
  );
}
